/**
 * MypageWishlistPresenter
 * --
 */
import React from 'react';
import { Content, Row, Col, Title } from 'components';
import { SideMenu } from '../components';

import MyItemList from '../components/ItemList/MyItemList';

const MypageWishlistPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { wishlist, screenSize } = props;

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 25,
      borderBottom: '2px solid var(--black-color)',
    },

    title: {
      fontSize: screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
      fontWeight: 700,
      color: 'var(--black-color)',
      fontFamily: 'Pretendard',
    },
  };

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content
      maxWidth={1820}
      padding={screenSize >= 768 ? '120px 0px' : '80px 0'}
    >
      <Row gutter={25}>
        <Col x={0} md={1} xl={2}></Col>
        <Col x={0} md={6} xl={4}>
          <SideMenu />
        </Col>
        <Col x={24} md={16} xl={16}>
          <Content
            maxWidth={'100%'}
            padding={
              screenSize >= 1200
                ? '0 0 0 95px'
                : screenSize >= 768
                ? '0 0 0 20px'
                : '0'
            }
          >
            {/* 위시리스트 */}
            <Content className="my_item_list" maxWidth={'100%'} padding={0}>
              <div
                style={{
                  ...styles.titleLayout,
                }}
              >
                <Title style={{ ...styles.title }}>위시리스트</Title>
              </div>
              <MyItemList
                title="위시리스트"
                items={wishlist}
                styles={styles}
                screenSize={screenSize}
              />
            </Content>
            {/* 위시리스트 끝 */}
          </Content>
        </Col>
        <Col x={0} md={1} xl={2}></Col>
      </Row>
    </Content>
  );
};

export default MypageWishlistPresenter;
